import { render, staticRenderFns } from "./FileBrowser.vue?vue&type=template&id=56d8a276&lang=pug"
import script from "./FileBrowser.vue?vue&type=script&lang=js"
export * from "./FileBrowser.vue?vue&type=script&lang=js"
import style0 from "./FileBrowser.vue?vue&type=style&index=0&id=56d8a276&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports